import React from 'react';
/**
 * Debounce changes to some value.
 *
 * Usage:
 * ```
 * useDebounce(
 *     someValue,
 *     React.useCallback( // it's important to use the useCallback hook here
 *         (debouncedValue) => {
 *             if (dep1 && dep2) {
 *                 console.log('Do something with', debouncedValue);
 *             }
 *         },
 *         [dep1, dep2], // it's important to set correct dependencies for the useCallback hook
 *     ),
 * );
 * ```
 *
 * @param value - value to debounce
 * @param callback - called when debounce delay expires
 * @param delay - debounce delay in milliseconds
 */
export function useDebounce(value, callback, delay) {
    React.useEffect(() => {
        const timer = window.setTimeout(() => callback(value), delay !== null && delay !== void 0 ? delay : 500);
        return () => {
            window.clearTimeout(timer);
        };
    }, [value, callback, delay]);
}
